import { render, staticRenderFns } from "./DeliveryQuotationLetter.vue?vue&type=template&id=08c4d375&scoped=true&"
import script from "./DeliveryQuotationLetter.vue?vue&type=script&lang=js&"
export * from "./DeliveryQuotationLetter.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryQuotationLetter.vue?vue&type=style&index=0&id=08c4d375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c4d375",
  null
  
)

export default component.exports